<template>
  <div class="form-container">
    <h2>LICENSE FORM</h2>
    <v-card outlined class="form-card mt-2">
      <v-card-title class="py-2">
        License Info
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-4">
        <div>
          <v-form v-model="form.valid">
            <v-row>
              <v-col cols="12">
                <Label text="Company" required>
                  <CompanySelect :company-id="form.companyId" :co-seq.sync="form.liCoSeq" :rules="rules.company" readonly />
                </Label>
              </v-col>
              <v-col cols="12">
                <Label text="Product" required>
                  <ProductSelect v-model="form.liPrdSeq" :rules="rules.product" />
                </Label>
              </v-col>
              <v-col cols="6">
                <Label text="License Count" required>
                  <v-text-field v-model="form.licenseCount" label="License Count" :rules="rules.licenseCount" />
                </Label>
              </v-col>
              <v-col cols="6">
                <Label text="End Date" required>
                  <DatePicker v-model="form.endDate" label="End Date" :rules="rules.endDate" />
                </Label>
              </v-col>
            </v-row>
          </v-form>
        </div>
      </v-card-text>
      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn color="error darken-1" outlined :loading="loading" @click="cancel">
          Cancel
        </v-btn>
        <v-btn color="blue darken-1" outlined :loading="loading" :disabled="!form.valid" @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { computed, defineComponent, getCurrentInstance } from 'vue'
import { useLicenseForm } from '@/views/license/composition/useLicense'
import { useSnackBar } from '@/composition/snackBar'
import { addLicense, LicenseForm } from '@/api/license/licenseApi'

export default defineComponent({
  name: 'LicenseAddForm',
  components: {
    Label: () => import('@/components/form/Label/index.vue'),
    CompanySelect: () => import('@/components/form/CompanySelector.vue'),
    ProductSelect: () => import('@/components/form/ProductSelect.vue'),
    DatePicker: () => import('@/components/form/DatePicker.vue')
  },
  setup(props) {
    const root = getCurrentInstance().proxy
    const companyId = root.$route.params.companyId
    const { form, save, rules, loading } = useLicenseForm(addLicense, new LicenseForm(companyId))
    const { open } = useSnackBar()

    return {
      companyId, form, rules, loading,
      async save() {
        const result = await save()
        if (result > 0) {
          open({ text: 'Saved successfully.', color: 'success' })
          root.$router.push({ name: 'CompanyDetail', param: { companyId: companyId.value }})
        } else {
          open({ text: 'An error occurred during processing.', color: 'error' })
        }
      },
      cancel() {
        root.$router.go(-1)
      }
    }
  }
})
</script>

<style scoped lang="scss">
</style>
